import React from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import "./DeviceSectionTitle.scss";

export const DeviceSectionTitle = ({ className }) => {
  return (
    <div className={classnames("device-section-title", className)}>
      <FormattedMessage id="manage_devices" />
    </div>
  );
};
